import axios from 'axios'
import { Message } from 'element-ui'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
	// baseURL: 'https://api.jijuxjs.com/',
	// baseURL: 'http://192.168.0.106:8081',
	baseURL: process.env.VUE_APP_API_BASE_URL,
  // 超时
  timeout: 10000
})

// request拦截器
service.interceptors.request.use(config => {
  return config
}, error => {
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 二进制数据则直接返回
  if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
    return res.data
  }
  return res.data
},
error => {
  // console.log('err' + error)
  let { message } = error
  if (message === 'Network Error') {
    message = '连接异常'
  } else if (message.includes('timeout')) {
    message = '请求超时'
  } else if (message.includes('Request failed with status code')) {
    message = '系统异常'
  }
  Message({ message: message, type: 'error', duration: 5 * 1000 })
  return Promise.reject(error)
}
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js